<div *ngIf="canDisplayTile" class="card card-shadow d-flex flex-column">
  <div class="card-body d-flex flex-column">
    <h3 class="card-title">Print Checks</h3>
    <h6 class="flex-grow-1">Processed payroll and need to print checks?</h6>
    <button
      (click)="clicked()"
      type="button"
      class="btn btn-primary float-end mt-auto align-self-end">
      Start Printing
    </button>
  </div>
</div>
